import { render, staticRenderFns } from "./MilestoneCom.vue?vue&type=template&id=71bc763c&scoped=true"
import script from "./MilestoneCom.vue?vue&type=script&lang=js"
export * from "./MilestoneCom.vue?vue&type=script&lang=js"
import style0 from "./MilestoneCom.vue?vue&type=style&index=0&id=71bc763c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bc763c",
  null
  
)

export default component.exports